import React from 'react';
import { connect } from 'react-redux';
import {
  closeGoStoreUnActivatedModal,
  closeSyncingProductDoneModal,
  closeSyncingProductEmptyProductModal,
  closeSyncingProductEmptySyncedModal,
  closeSyncingProductInSyncModal,
  startPostSyncingProductFlow,
  startSyncingProductFlow,
} from 'actions/onlineStore';
import restrictedIcon from 'assets/images/backoffice/online-store/restricted.svg';
import emptyIcon from 'assets/images/backoffice/online-store/empty.svg';
import WarningModal from '../WarningModal';
import ProductSyncingInSyncModal from '../ProductSyncingInSyncModal';
import ProductSyncingResultModal from '../ProductSyncingResultModal';
import CompleteSetupModal from '../CompleteSetupModal';

const channelSpecificText = {
  facebook: {
    empty_product_modal: {
      text: 'Create product to be uploaded on Facebook and Instagram Shop!',
    },
    empty_synced_modal: {
      text: 'No Product has been uploaded to your Facebook and Instagram Shop.',
      button_text: 'Upload Products to Facebook',
    },
  },
  google: {
    empty_product_modal: {
      text: 'Create product to be uploaded on Google!',
    },
    empty_synced_modal: {
      text: 'No product has been uploaded to Google.',
      button_text: 'Upload products to Google',
    },
  },
};

class ProductSyncingModal extends React.Component {
  render() {
    const { productSyncing, outlets, shopDetail } = this.props;
    if (!shopDetail) {
      return null;
    }

    const channel = shopDetail.channel.toLowerCase();
    const outlet =
      outlets.filter(o => o.id === shopDetail.outlet_id)[0] || outlets[0];

    if (productSyncing.showSyncProductEmptyProductModal) {
      return (
        <WarningModal
          imageSrc={emptyIcon}
          title="Upload Products for"
          titleBold={outlet.name}
          subTitle={"Oops, you don't have any product yet."}
          text={channelSpecificText[channel].empty_product_modal.text}
          buttonText={'Create Item Now'}
          onHide={this._handleCloseEmptyProductModal}
          onClick={this._handleClickCreateItemNow}
        />
      );
    }

    if (productSyncing.showGoStoreUnActivatedModal) {
      return (
        <WarningModal
          imageSrc={restrictedIcon}
          title="Upload Products for"
          titleBold={outlet.name}
          text={
            "Oops. you can't sync any product because your GoStore for this outlet is not activated yet."
          }
          buttonText={'Active GoStore Now'}
          onHide={this._handleCloseGoStoreUnActivatedModal}
        />
      );
    }

    if (productSyncing.showSyncProductEmptySyncedModal) {
      return (
        <WarningModal
          imageSrc={emptyIcon}
          title="Upload Products for"
          titleBold={outlet.name}
          subTitle={channelSpecificText[channel].empty_synced_modal.text}
          buttonText={
            channelSpecificText[channel].empty_synced_modal.button_text
          }
          onHide={this._handleCloseEmptySyncedModal}
          onClick={this._handleStartSyncProductFlow}
        />
      );
    }

    if (productSyncing.showSyncingProductInSyncModal) {
      return (
        <ProductSyncingInSyncModal
          title="Upload Products for"
          titleBold={outlet.name}
          onHide={this._handleCloseInSyncModal}
        />
      );
    }

    if (productSyncing.showSyncingProductResultModal) {
      return (
        <ProductSyncingResultModal
          title="Upload Products for"
          titleBold={outlet.name}
          onHide={this._handleCloseResultModal}
        />
      );
    }

    if (productSyncing.showSyncingProductDoneModal) {
      return (
        <CompleteSetupModal
          outletName={outlet.name}
          onHide={this._handleCloseDoneModal}
        />
      );
    }

    return null;
  }

  _handleCloseEmptyProductModal = () => {
    this.props.dispatch(closeSyncingProductEmptyProductModal());
  };

  _handleCloseGoStoreUnActivatedModal = () => {
    this.props.dispatch(closeGoStoreUnActivatedModal());
  };

  _handleCloseEmptySyncedModal = () => {
    this.props.dispatch(closeSyncingProductEmptySyncedModal());
  };

  _handleStartSyncProductFlow = () => {
    const { shopDetail } = this.props;
    this.props.dispatch(startSyncingProductFlow(shopDetail.id, false));
  };

  _handleCloseInSyncModal = () => {
    this.props.dispatch(closeSyncingProductInSyncModal());
  };

  _handleCloseResultModal = () => {
    this.props.dispatch(startPostSyncingProductFlow());
  };

  _handleCloseDoneModal = () => {
    this.props.dispatch(closeSyncingProductDoneModal());
  };

  _handleClickCreateItemNow = () => {
    window.location.href = '/library/list';
  };
}

function mapStateToProps(state) {
  const { productSyncing, shop } = state.onlineStore;
  const { outlets } = state.moka.user;

  return {
    outlets,
    productSyncing,
    shopDetail: shop.shopDetail,
  };
}

export default connect(mapStateToProps)(ProductSyncingModal);
